import React from 'react'

import logo from '../assets/images/logo.png';
import Links from './Links';

const Badge = () => (<a 
    style={{position: 'absolute', border: 'none', width: '190px',top: '20px', right: '20px'}} 
    href="https://www.producthunt.com/posts/muzie?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-muzie" 
    target="_blank"
>
    <img 
        src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=147482&theme=light" 
        alt="Muzie - The all in one music streaming app | Product Hunt Embed" 
        style={{width: '100%'}} 
    />
</a>)

const Header = (props) => (
    <header id="header" className="alt">
        <Badge />
        <span className="logo"><img src={logo} alt="" /></span>
        <h1>Muzie</h1>
        <p>The all in one music streaming app</p>
        <Links/>
    </header>
)

export default Header
